import { auth } from '@/services/auth'

const getUser = ({commit}) => {
  commit('SET_USER', auth.getUser())
}

export default {
  getUser
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js